/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { CloseMobile } from '@/icons/index';
import { Button } from '@/ui/index';

import styles from './SwapError.module.scss';

const SwapError = ({
  active = false,
  setActive = () => null,
  className,
  classNameInner,
}) => {
  const { t } = useTranslation();

  const closeModal = (event) => {
    if (event.key === 'Escape') {
      setActive(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('keydown', closeModal);

    return () => {
      document.removeEventListener('keydown', closeModal);
    };
  }, [closeModal]);

  return (
    <div
      className={classNames([
        styles.wrap,
        { [styles.open]: active },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Alret'
    >
      <div className={classNames([styles.pinInner, classNameInner])}>
        <div className={styles.pinContent}>
          <h5 className={styles.title}>
            {t('esim:checkout.modals.swapError.attention')}
          </h5>
          <p
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: t('esim:checkout.modals.swapError.error'),
            }}
          ></p>

          <div className={styles.close} onClick={() => setActive(false)}>
            <CloseMobile />
          </div>
          <Button
            onClick={() => setActive(false)}
            className={styles.close_btn}
            variant='outline'
          >
            {t('esim:checkout.actions.close')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SwapError;
